import { Component, OnInit } from '@angular/core';
import { StoreService } from 'src/app/store.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { NavigationExtras, ActivatedRoute, Router } from '@angular/router';
import { UtilitiesService } from 'src/app/core/utilities.service';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { PLATFORM } from 'src/app/core/constants/data.constant';
import { StoreInfoService } from 'src/app/store-info.service';


@Component({
  selector: 'app-list-stores',
  templateUrl: './express-checkout.component.html',
  styleUrls: ['./express-checkout.component.scss'],
})
export class ExpressCheckoutComponent implements OnInit {
  bearer;
  store_id;
  checkout_list = [];
  link_list = [];
  link_data: any = {};
  isSvoStore = false;
  isStoreInfoLoading = true;



  filteredCountry = '';
  country = [];

  // loading = true;
  closeResult = '';
  success = 'success';
  modalDelete = true;

  checkoutPaginationList = [];
  page = 1;
  selectedPage = 10;
  start = 0;
  end = 0;
  expanded = [];
  twSubscriptionStatus = false;

  filterTable = [
    {
      filterName: 'selectedOrderType',
      filterCallback: (orderData, filterValue) => {
        if (filterValue === 'normal') {
          return ![2, 3, 4, 5, 7].includes(+orderData.link_type);
        } else if (filterValue === 'express_checkout') {
          return +orderData.link_type === 2;
        } else if (filterValue === 'aemis') {
          return +orderData.link_type === 3;
        } else if (filterValue === 'subscription') {
          return +orderData.link_type === 4;
        } else if (filterValue === 'pre_order') {
          return +orderData.link_type === 5;
        } else if (filterValue === 'repurchase') {
          return +orderData.link_type === 7;
        }
        return false;
      },
    },
    {
      filterName: 'selectedPlatformType',
      filterCallback: (orderData, filterValue) =>
        orderData?.platform === filterValue,
    },
  ];

  dataIsLoading = true;
  selectedOrderType; // = { display:'All', value:'ALL' };
  selectedPlatformType; // = { display:'All', value:'ALL' };
  orderTypeFilters = [];
  platformTypeFilters = [];
  countryCtrl: FormControl;

  filteredCheckout: Observable<any[]>;
  filteredCheckoutList;
  searchNameData;
  filterList;

  constructor(
    private svc: StoreService,
    private modalService: NgbModal,
    public utils: UtilitiesService,
    private router: Router,
    private storeInfoService: StoreInfoService
  ) { }


  ngOnInit(): void {
    this.bearer = localStorage.getItem('bearer');
    this.store_id = localStorage.getItem('store_id');
    this.getTWSubscriptionStatus();
    this.fetchCountry();
    this.updateCheckoutList();
    this.getStoreInfo();
  }

  getStoreInfo() {
    this.storeInfoService.getStoreInfos().subscribe((res) => {
      this.isSvoStore = res?.config?.is_svo_store;
      this.isStoreInfoLoading = false;
    });
  }



  getTWSubscriptionStatus() {
    this.svc.getTWSubscriptionStatus(this.bearer).subscribe(
      (res) => {
        this.twSubscriptionStatus = res['data'] && res['data'] === '1';
      },
      (error) => {
        this.twSubscriptionStatus = false;
        console.log(error);
      }
    );
  }

  sliceCart() {
    this.start = Math.round((this.page - 1) * this.selectedPage);
    this.end = this.start + this.selectedPage;
    this.end =
      this.end > this.filterList.length ? this.filterList.length : this.end;
    this.end = this.end > this.start ? this.end : this.start;

    // Sort listing by created_at date
    this.filterList.sort((a, b) => b.created_at.localeCompare(a.created_at));

    this.checkoutPaginationList = this.filterList.slice(this.start, this.end);
    if (this.checkoutPaginationList.length > 0) {
      this.checkoutPaginationList.forEach((value, index) => {
        this.expanded[index] = false;
      });
    }
  }

  get filteredOrderHistoryList() {
    const selectedFilters = {};
    const filterTable = this.filterTable;

    Object.values(filterTable).forEach(({ filterName, filterCallback }) => {
      const value = this[filterName]?.value;
      if (value !== undefined && value !== 'ALL' && value !== '') {
        selectedFilters[filterName] = value;
      } else if (value === 'ALL') {
        if (this.searchNameData) {
          const searchTerms = this.searchNameData
            .toString()
            .toLowerCase()
            .split(/\s+/) // Split the search term into individual words
            .filter((term) => term !== ''); // Remove empty terms

          this.checkoutPaginationList = this.checkout_list.filter((checkout) =>
            searchTerms.every(
              (term) =>
                (checkout.page_title || '').toLowerCase().includes(term) ||
                (checkout.page_subtitle || '').toLowerCase().includes(term)
            )
          );

          this.filterList = this.checkoutPaginationList;
          this.sliceCart();
        }
      }
    });
    this.filteredCheckoutList = this.checkout_list;
    if (this.searchNameData === undefined || this.searchNameData === '') {
      this.filterList = this.checkout_list;
      this.sliceCart();
    }

    if (Object.keys(selectedFilters).length === 0) {
      return this.checkoutPaginationList;
    } else {
      Object.keys(selectedFilters).forEach((filterKey) => {
        const filterValue = selectedFilters[filterKey];
        const filterData = this.getFilterDataByName(filterKey);

        this.filteredCheckoutList = this.filteredCheckoutList.filter((item) =>
          filterData?.filterCallback(item, filterValue)
        );
      });
      this.filterList = this.filteredCheckoutList;

      if (this.searchNameData) {
        const searchTerms = this.searchNameData
          .toString()
          .toLowerCase()
          .split(/\s+/) // Split the search term into individual words
          .filter((term) => term !== ''); // Remove empty terms

        let filter = this.filteredCheckoutList.filter((checkout) =>
          searchTerms.every(
            (term) =>
              (checkout.page_title || '').toLowerCase().includes(term) ||
              (checkout.page_subtitle || '').toLowerCase().includes(term)
          )
        );

        this.checkoutPaginationList = filter;

        this.filteredCheckoutList = this.checkoutPaginationList;
        this.filterList = this.checkoutPaginationList;
        this.sliceCart();
      }
      this.sliceRecord();
      return this.filteredCheckoutList;
    }
  }

  sliceRecord() {
    this.start = Math.round((this.page - 1) * this.selectedPage);
    this.end = this.start + this.selectedPage;
    this.end =
      this.end > this.filteredCheckoutList.length
        ? this.filteredCheckoutList.length
        : this.end;
    this.end = this.end > this.start ? this.end : this.start;
    this.filteredCheckoutList = this.filteredCheckoutList.slice(
      this.start,
      this.end
    );
  }

  getFilterDataByName(filterName) {
    return this.filterTable.find(
      (filter) => filter?.filterName.toLowerCase() === filterName.toLowerCase()
    );
  }

  selectPage(page: any) {
    this.selectedPage = page;
    this.page = 1;
    this.sliceCart();
  }

  changePage(pageOfItems) {
    this.page = pageOfItems;
    this.sliceCart();
  }

  updateCheckoutList() {
    this.dataIsLoading = true;
    if (this.link_list.length <= 0) {
      this.modalService.dismissAll('Cross click');
    }
    // this.loading = true;
    this.svc
      .getCheckoutLinkLists(this.bearer, this.store_id)
      .subscribe((res) => {
        let me = this;
        me.checkout_list = res['data']?.reverse();
        this.filterList = me.checkout_list;

        console.log('EC list =', me.checkout_list);
        const platformFilters = [
          'ALL',
          ...[...new Set(this.filterList.map((item) => item.platform))].sort(),
        ];
        this.platformTypeFilters = platformFilters.map((item) => ({
          display: this.getPlatformType(item)?.display,
          value: item,
        }));

        this.orderTypeFilters = [
          { display: 'View All', value: 'ALL' },
          { display: 'Normal', value: 'normal' },
          { display: 'Express Checkout', value: 'express_checkout' },
          { display: 'Aemis', value: 'aemis' },
          { display: 'Subscription', value: 'subscription' },
          { display: 'Pre Order', value: 'pre_order' },
          { display: 'Repurchase', value: 'repurchase' },
        ];

        this.sliceCart();
        this.dataIsLoading = false;
      });
  }

  getPlatformType(key) {
    return PLATFORM[key?.toUpperCase()];
  }

  modalMode = 'view';

  openLink(openlink, id, mode = 'view') {
    this.link_list = id.link_list;
    this.link_data = id;
    this.modalMode = mode;

    // Fetch Nexus links for each item in link_list if eligible
    if (this.link_list && this.link_list.length > 0) {
      if (
        id.link_type == 1 ||
        id.link_type == 2 ||
        id.order_type_id == 1 ||
        id.order_type_id == 2
      ) {
        this.link_list.forEach(item => {
          if (!item.sso_link && !item.sso_loading) {
            this.getNexusLinkForModal(item, id);
          }
        });
      }
    }

    this.modalService
      .open(openlink, {
        size: 'lg',
        backdrop: 'static',
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  getNexusLinkForModal(item, parentData) {
    item.sso_loading = true;
    const nexusBody = {
      store_id: this.store_id,
      checkout_link_id: parentData.checkout_link_id, // Use parent's ID as items in list might not have it or it's the same
      promotional_text: parentData.description || parentData.page_subtitle || '',
    };

    this.svc.getNexusInfo(nexusBody, this.bearer).subscribe(
      (nexusRes) => {
        item.sso_loading = false;
        if (nexusRes['data']?.sso_link) {
          item.sso_link = nexusRes['data'].sso_link;
        }
      },
      (nexusError) => {
        item.sso_loading = false;
        console.log('Nexus API error for item', item, nexusError);
      }
    );
  }

  open(content, id) {
    this.modalService
      .open(content, {
        ariaLabelledBy: 'modal-basic-title',
        centered: true,
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
          if (result == 'delete') {
            this.deleteCheckoutLink(id);
          }
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  deleteCheckoutLink(id) {
    // this.loading = true;
    let status = 0;
    let body = {
      status: status,
      store_id: this.store_id,
      url: id.url,
      country_code: id.country_code,
    };
    this.svc.removeCheckoutLink(this.bearer, body).subscribe(
      (res) => {
        setTimeout(() => {
          this.utils.notify.showSuccess(this.utils.translate("Deleted Successfully!"));
          this.updateCheckoutList();
          // location.reload();
        }, 2000);
      },
      (error) => {
        console.log(error);
        this.utils.notify.showError(this.utils.translate("Update Failed!"));
      }
    );
  }

  deleteLink(data) {
    let indexremove = this.link_list.indexOf(data);
    this.link_list.splice(indexremove, 1);
    // this.loading = true;
    let status = 0;
    let body = {
      checkout_link_id: data.checkout_link_id,
      status: status,
      store_id: this.store_id,
      country_code: data.country_code,
      language_code: data.language_code,
    };
    this.svc.updateCheckoutLink(this.bearer, body).subscribe(
      (res) => {
        setTimeout(() => {
          this.utils.notify.showSuccess(this.utils.translate("Deleted Successfully!"));
          this.updateCheckoutList();
          // location.reload();
        }, 2000);
      },
      (error) => {
        console.log(error);
        this.utils.notify.showError(this.utils.translate("Update Failed!"));
      }
    );
  }

  edit(checkoutUrl, countryCode) {
    this.router.navigateByUrl(
      `/dashboard/express-checkout/edit/${countryCode.toLowerCase()}/${checkoutUrl}`
    );
  }

  share(data) {
    if (data?.sso_link) {
      // Track Mixpanel event
      this.trackShareEvent('Express Checkout Share Success');
      window.open(data.sso_link, '_blank');
    } else if (data?.sso_loading) {
      this.utils.notify.showInfo(this.utils.translate('Creating share link... please wait.'));
    } else {
      this.utils.notify.showError(this.utils.translate('Share link not available'));
      this.trackShareEvent('Express Checkout Share Fail');
    }
  }

  // Share the product link: reuse the Nexus sso_link but swap its checkout_url
  // query param for the product-link URL (domain/go/slug).
  shareProductLink(data) {
    if (data?.sso_link) {
      this.trackShareEvent('Express Checkout Share Success');
      const shareUrl = this.withCheckoutUrl(data.sso_link, this.productGoUrl(data.domain_url));
      window.open(shareUrl, '_blank');
    } else if (data?.sso_loading) {
      this.utils.notify.showInfo(this.utils.translate('Creating share link... please wait.'));
    } else {
      this.utils.notify.showError(this.utils.translate('Share link not available'));
      this.trackShareEvent('Express Checkout Share Fail');
    }
  }

  private withCheckoutUrl(ssoLink: string, checkoutUrl: string): string {
    if (!checkoutUrl) return ssoLink;
    try {
      const url = new URL(ssoLink);
      url.searchParams.set('checkout_url', checkoutUrl);
      return url.toString();
    } catch (e) {
      return ssoLink;
    }
  }

  // The product link URL shown / copied / opened. domain_url is "domain/slug";
  // the product URL inserts a /go/ redirect segment -> "domain/go/slug".
  productGoUrl(domainUrl: string): string {
    if (!domainUrl) return '';
    try {
      const url = new URL(domainUrl);
      const slug = url.pathname.replace(/^\/+/, '');
      return `${url.origin}/go/${slug}`;
    } catch (e) {
      return domainUrl;
    }
  }

  createNew() {
    localStorage.removeItem('express_checkout_edit');
  }

  fetchCountry() {
    this.svc.getCountry(this.bearer).subscribe((res) => {
      res['data'].forEach((item) => {
        if (item['country_name'] == 'Malaysia-Brunei') {
          item['country_name'] = 'Brunei';
        }
      });
      let defaultCountry = res['data'].find((index) => {
        if (parseInt(index['default']) === 1) {
          return index;
        }
      });

      this.country = [{ country_code: '', country_name: '' }];
      this.filteredCountry = defaultCountry['country_code'] ?? 'MY';
      if (res['data']) {
        res['data'].forEach((value) => {
          value.country_name = value.country_name.split('-').pop().trim();
          this.country.push(value);
        });
      }
    });
  }

  languageMap: { [key: string]: string } = {
    'en': 'English',
    'en-us': 'English',
    'en-gb': 'English',
    'ms': 'Bahasa Malaysia',
    'ms-my': 'Bahasa Malaysia',
    'my': 'Bahasa Malaysia',
    'zh': '简体中文',
    'zh-cn': '简体中文',
    'zh-tw': '繁體中文',
    'zh-hk': '繁體中文',
    'tw': '繁體中文',
    'cn': '简体中文',
    'id': 'Bahasa Indonesia',
    'id-id': 'Bahasa Indonesia',
    'th': 'ไทย',
    'th-th': 'ไทย',
    'vi': 'Tiếng Việt',
    'vi-vn': 'Tiếng Việt',
    'ja': '日本語',
    'ja-jp': '日本語',
    'ko': '한국어',
    'ko-kr': '한국어',
    'es': 'Español',
    'es-es': 'Español',
    'fr': 'Français',
    'fr-fr': 'Français',
    'de': 'Deutsch',
    'de-de': 'Deutsch',
    'km': 'ភាសាខ្មែរ',
    'km-kh': 'ភាសាខ្មែរ',
    'tl': 'Filipino',
    'tl-ph': 'Filipino',
  };

  getLanguageName(codeOrName: string): string {
    if (!codeOrName) return '';
    const clean = codeOrName.trim().toLowerCase();
    if (this.languageMap[clean]) {
      return this.languageMap[clean];
    }
    return codeOrName;
  }

  getModalLanguages(): string {
    if (this.link_data?.language_name) {
      return this.getLanguageName(this.link_data.language_name);
    }
    if (this.link_data?.language_code) {
      return this.getLanguageName(this.link_data.language_code);
    }
    if (this.link_list && this.link_list.length > 0) {
      const langs = Array.from(
        new Set(
          this.link_list
            .map((item) =>
              this.getLanguageName(item?.language_name || item?.language_code || item?.language)
            )
            .filter((name) => !!name)
        )
      );
      if (langs.length > 0) {
        return langs.join(', ');
      }
    }
    return '';
  }

  // A checkout has a product link if any of its language variants (link_list)
  // carries a non-empty domain_url.
  hasProductLink(data): boolean {
    return (data?.link_list || []).some((link) => !!link?.domain_url);
  }

  getCountryName(country_code: string) {
    country_code = (country_code || '').toLowerCase();
    const country = this.country?.find(
      (c) => (c.country_code || '').toLowerCase() === country_code
    );

    return country?.country_name ?? country_code;
  }

  getFlagByCountryCode(country_code: string) {
    country_code = (country_code || '').toLowerCase().substr(-2, 2);
    country_code = country_code === 'cm' ? 'kh' : country_code;
    return country_code;
  }

  getFlagImageURL(country_code: string) {
    if (!country_code || country_code.trim() === '') {
      country_code = 'zz';
    } else {
      country_code = this.getFlagByCountryCode(country_code);
    }
    return `https://cdn.estore5s.com/asset/flags/${country_code}.png`;
  }

  get getSelectedCountryCode(): string {
    return this.filteredCountry?.toUpperCase();
  }

  onSearchChange() {
    this.page = 1;
    if (this.searchNameData) {
      const searchTerms = this.searchNameData
        .toString()
        .toLowerCase()
        .split(/\s+/) // Split the search term into individual words
        .filter((term) => term !== ''); // Remove empty terms

      this.checkoutPaginationList = this.checkout_list.filter((checkout) =>
        searchTerms.every(
          (term) =>
            (checkout.page_title || '').toLowerCase().includes(term) ||
            (checkout.page_subtitle || '').toLowerCase().includes(term)
        )
      );

      this.filterList = this.checkoutPaginationList;
      this.sliceCart();
    } else {
      this.filterList = this.checkout_list;
      this.sliceCart();
    }
  }

  clearSearch() {
    this.searchNameData = '';
    this.onSearchChange();
  }

  trackShareEvent(eventType: string) {
    const info = JSON.parse(localStorage.getItem('5s-info') || '{}');
    const dealerId = info.d_id || '';

    const dataEvent = {
      data: {
        d_id: dealerId,
        type: eventType,
        distinct_id: dealerId,
      },
      application: 'dashboard',
      driver: 'mixpanel',
    };

    this.svc.publish_event(dataEvent).subscribe(
      (res) => {
        console.log('Mixpanel event tracked:', { res });
      },
      (error) => {
        console.log('Mixpanel tracking error:', { error });
      }
    );
  }
}
